import React, { useState, useEffect } from 'react';
import { getClientRoles } from '../services/admin_api';
import { JSONParser } from '@amcharts/amcharts5';

const ChooseUserRoles = ({ clientId, selectedRoles, onRolesChange }) => {
    const [availableRoles, setAvailableRoles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    console.log(selectedRoles);
    useEffect(() => {
        if (!clientId) {
            setAvailableRoles([]);
            return;
        }

        const fetchRoles = async () => {
            setLoading(true);
            setError(null);
            try {
                const apps = await getClientRoles(clientId);
                console.log('Fetched client:', apps);
                setAvailableRoles(apps || []);
            } catch (err) {
                setError('Failed to fetch roles.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchRoles();
    }, [clientId]);

    const handleRoleChange = (role) => {
        const currentIndex = selectedRoles.indexOf(role);
        const newRoles = [...selectedRoles];

        if (currentIndex === -1) {
            newRoles.push(role);
        } else {
            newRoles.splice(currentIndex, 1);
        }

        onRolesChange(newRoles);
    };

    if (loading) {
        return <div>Loading roles...</div>;
    }

    if (error) {
        return <div style={{ color: 'red' }}>{error}</div>;
    }

    if (!clientId) {
        return <div>Please select a client to see available roles.</div>;
    }

    // S'assurer que selectedRoles est toujours un tableau
    const currentSelectedRoles = Array.isArray(selectedRoles) ? selectedRoles : [];

    return (
        <div>
            <label>Roles</label>
            <div style={{ display: 'flex', flexDirection: 'column', maxHeight: '150px', overflowY: 'auto', border: '1px solid #ccc', padding: '10px' }}>
                {availableRoles.map((role) => (
                    <label key={role} style={{ marginBottom: '5px' }}>
                        <input
                            type="checkbox"
                            value={role}
                            checked={currentSelectedRoles.includes(role)}
                            onChange={() => handleRoleChange(role)}
                        />
                        {role}
                    </label>
                ))}
            </div>
        </div>
    );
};

export default ChooseUserRoles;
